import React from 'react';

const FacebookIcon = () => {
  return (
    <svg
      width='52'
      height='30'
      viewBox='0 0 52 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='52' height='30' rx='15' fill='url(#facebook_gradient)' />
      <path
        d='M26.9296 9.63906C26.9296 8.95508 27.5255 8.70937 28.1927 8.70937C28.8599 8.70937 29.5725 8.92187 29.5725 8.92187L30 6.31875C30 6.31875 29.0931 6 26.9296 6C25.6016 6 24.8308 6.51797 24.2672 7.28164C23.736 8.00547 23.7166 9.16758 23.7166 9.91797V11.6246H22V14.168H23.7166V23H26.9296V14.168H29.4753L29.6632 11.6246H26.9296V9.63906Z'
        fill='#043C67'
      />
      <defs>
        <linearGradient
          id='facebook_gradient'
          x1='5.32716e-06'
          y1='30'
          x2='28.5211'
          y2='-14.9106'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#E6E6FF' />
          <stop offset='0.5' stopColor='#E5EFFE' />
          <stop offset='1' stopColor='#CCF8FF' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default FacebookIcon;
